// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__yhI3v","colCheckbox":"styles_colCheckbox__1S3ut"};